import {
  PlusIcon,
  AcademicCapIcon,
  LightBulbIcon,
  ShieldCheckIcon,
  CreditCardIcon,
  DevicePhoneMobileIcon,
  CircleStackIcon,
  HeartIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  ArrowTrendingUpIcon,
} from "@heroicons/react/24/outline";
import { Fifth } from "../../components/buttons/Fifth";
import { Home } from "../../components/backgrounds/Home";
import { Media } from "../../components/home/Media";

const features = [
  {
    name: "Inclusión",
    description:
      "Históricamente ha existido una parte de la población que ha quedado excluída del sistema financiero, por eso, en Galilea construimos productos que estén al alcance de quiénes más lo necesitan permitiendo dar ese salto entre la exclusión a la bancarización.",
    icon: PlusIcon,
  },
  {
    name: "Educación",
    description:
      "Creemos firmemente que la educación es el motor del cambio. Los productos y servicios financieros deben ser explicados de forma clara a las personas sin tecnisismos.",
    icon: AcademicCapIcon,
  },
  {
    name: "Seguridad financiera",
    description:
      "Dentro de nuestros objetivos a la sociedad, es seguramente uno de los más ambiciosos. Pero sentar las bases para una sociedad libre y segura financieramente es un principio que nos mueve como equipo.",
    icon: ShieldCheckIcon,
  },
  {
    name: "Innovación",
    description:
      "Como en muchas industrias la tecnología ha llegado para democratizar el acceso a nuevos productos y servicios. En Galilea construimos día tras día herramientas que nos permitan disminuir la brecha que ha existido al sistema financiero.",
    icon: LightBulbIcon,
  },
];

export function NosotrosPage() {
  return (
    <div className="bg-white">
      <Home
        title={
          "Estamos cambiando la manera en la que te relacionas con los servicios financieros"
        }
        description={
          "Galilea será el banco digital líder de inclusión financiera en Colombia y Latinoamérica. Aspiramos a transformar la vida de millones de personas mediante soluciones tecnológicas innovadoras que impulsen el crecimiento económico sostenible, promuevan la equidad y reduzcan las desigualdades financieras en la región."
        }
      />
      <main>
        {/* Historia de Galilea */}
        <div className="bg-purpleLight">
          <div className="block lg:hidden right-0 w-full h-110">
            <img
              className="right-0 h-full"
              src="/jpg/TRY6.jpg"
              alt="Galilea-coworking"
            />
          </div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-28">
            <div className="flex">
              <div className="max-w-2xl pr-8 text-xl">
                <h1 className="text-4xl font-bold">Nuestra Historia</h1>
                <p className="pt-10">
                  A mediados de 2019 cuando Angie Ávila y William Antonio se
                  encontraban terminando sus estudios en la universidad, se
                  plantearon la idea de combatir los créditos informales ‘gota a
                  gota’ que popularmente se conocían y que, ante la ausencia de
                  la banca tradicional en algunos sectores económicos, las
                  personas no tenían otra alternativa mas que recurrir a ellos.
                </p>
                <p className="pt-10">
                  Gracias a los años de trabajo que moldearon nuevas soluciones
                  crediticias en base a la tecnología como aliada, Galilea es
                  hoy una de las fintech de crédito digital de más rápido
                  crecimiento en Colombia con más de 4.000 clientes en menos de
                  8 meses de operación que tiene como misión cambiar la manera
                  en que las personas se relacionan con el sistema financiero
                  fomentando la inclusión financiera.
                </p>
              </div>
              <div className="hidden lg:block absolute right-0 w-full h-110">
                <img
                  className="absolute right-0 h-full"
                  src="/jpg/TRY6.jpg"
                  alt="Galilea-coworking"
                />
              </div>
            </div>
          </div>
        </div>
        {/* Seccion de cultura de Galilea */}
        <div className="bg-grayM overflow-hidden font-walsheim text-tdark">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-28">
            <div className="lg:grid lg:grid-cols-3 lg:gap-x-8">
              <div className="lg:col-span-1">
                <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
                  La cultura en Galilea
                </h2>
              </div>
              <dl className="mt-10 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-8 sm:gap-y-10 lg:mt-0 lg:col-span-2">
                {features.map((feature) => (
                  <div key={feature.name}>
                    <dt>
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-purple text-white">
                        <feature.icon className="h-6 w-6" aria-hidden="true" />
                      </div>
                      <p className="mt-5 text-xl leading-6 font-bold text-gray-900">
                        {feature.name}
                      </p>
                    </dt>
                    <dd className="mt-2 text-lg">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
        {/* Seccion de cultura de Galilea */}
        <div className="bg-purpleLight overflow-hidden font-walsheim text-tdark">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-28">
            <div>
              <h2 className="text-3xl text-center font-bold tracking-tight sm:text-4xl">
                Diferenciadores clave de Galilea
              </h2>
            </div>
            <div className="pt-14 md:pt-28">
              <div className="md:flex justify-between gap-8">
                <div className="w-full pb-10 md:pb-16">
                  <div className="h-12 w-12 bg-purple rounded-md mb-4">
                    <CreditCardIcon className="text-white p-3" />
                  </div>
                  <div className="font-bold text-xl">
                    Crédito accesible y personalizado:
                  </div>
                  <div className="text-lg">
                    Permite el acceso al crédito a personas con poco historial
                    financiero, evaluando más que solo el puntaje de crédito
                    tradicional.
                  </div>
                </div>
                <div className="w-full pb-10 md:pb-16">
                  <div className="h-12 w-12 bg-purple rounded-md mb-4">
                    <DevicePhoneMobileIcon className="text-white p-3" />
                  </div>
                  <div className="font-bold text-xl">
                    100% digital y sin trámites engorrosos:
                  </div>
                  <div className="text-lg">
                    Procesos completamente en línea, eliminando filas, papeleo y
                    largos tiempos de espera.
                  </div>
                </div>
                <div className="w-full pb-10 md:pb-16">
                  <div className="h-12 w-12 bg-purple rounded-md mb-4">
                    <CircleStackIcon className="text-white p-3" />
                  </div>
                  <div className="font-bold text-xl">
                    Uso inteligente de datos y tecnología:
                  </div>
                  <div className="text-lg">
                    IA y automatización para mejorar la toma de decisiones y
                    ofrecer mejores condiciones de crédito.
                  </div>
                </div>
              </div>
              <div className="md:flex justify-between gap-8">
                <div className="w-full pb-10 md:pb-16">
                  <div className="h-12 w-12 bg-purple rounded-md mb-4">
                  <HeartIcon className="text-white p-3" />
                  </div>
                  <div className="font-bold text-xl">
                    Modelo de cobranza eficiente y humano:
                  </div>
                  <div className="text-lg">
                    Estrategias basadas en segmentación y comunicación efectiva
                    sin afectar la relación con el cliente.
                  </div>
                </div>
                <div className="w-full pb-10 md:pb-16">
                  <div className="h-12 w-12 bg-purple rounded-md mb-4">
                  <ChatBubbleOvalLeftEllipsisIcon className="text-white p-3" />
                  </div>
                  <div className="font-bold text-xl">
                    Atención al cliente con tecnología y cercanía:
                  </div>
                  <div className="text-lg">
                    Unificación de canales (WhatsApp, correo, SMS) con
                    automatización e intervención humana cuando se requiera.
                  </div>
                </div>
                <div className="w-full pb-10 md:pb-16">
                  <div className="h-12 w-12 bg-purple rounded-md mb-4">
                  <ArrowTrendingUpIcon className="text-white p-3" />
                  </div>
                  <div className="font-bold text-xl">
                    Modelo escalable y sostenible:
                  </div>
                  <div className="text-lg">
                    Estructura optimizada para atraer inversionistas y
                    financiamiento estratégico, garantizando crecimiento
                    rentable y expansión regional.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Lo que la prensa habla de nosotros */}
        <Media />
      </main>
    </div>
  );
}
